import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  Typography,
  Avatar,
  IconButton
} from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: '12px 16px 18px 16px',
    borderRadius: 14,
    backgroundColor: '#ffffff',
    border: '1px solid #ededed',
    transition: 'all .2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    }
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 6,
  },
  left: {
    display: 'flex',
    gap: 12,
  },
  avatar: {
    backgroundColor: '#1565c0',
    width: 36,
    height: 36,
    fontWeight: 600,
    fontSize: 13,
  },
  title: {
    fontSize: 15,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  subheader: {
    fontSize: 12,
    color: '#777',
    lineHeight: 1.4,
    marginTop: 2,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 18,
  },
  image: {
    width: 56,
    height: 56,
    objectFit: 'contain',
  },
  description: {
    fontSize: 13,
    marginTop: 16,
    color: '#444',
    lineHeight: 1.5,
  }
}));


export default function SisefCardProcesos({ procesos, nombre, descripcion, imagen, onDelete, admin = false }) {
  const classes = useStyles();

  return (
    <Card className={classes.card} elevation={0}>
      <div className={classes.header}>
        <div className={classes.left}>
          <Avatar className={classes.avatar}>
            {nombre?.charAt(0).toUpperCase()}
          </Avatar>
          <div>
            <Typography className={classes.title}>
              {nombre}
            </Typography>
            <Typography className={classes.subheader}>
              {procesos}
            </Typography>
          </div>
        </div>
        {
          admin && (
            <IconButton size="small" onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          )
        }
      </div>
      {imagen && (
        <div className={classes.imageContainer}>
          <img
            src={imagen}
            alt="Imagen"
            className={classes.image}
          />
        </div>
      )}
      <Typography className={classes.description}>
        {descripcion}
      </Typography>
    </Card>
  );
}
